<template>
  <div class="player-panel">
    <!--  -->
    <Transition name="panel-up">
      <div v-if="displayPanel" class="panel">
        <a :class="{'close': !displayPanel}" class="panel-close" @click="togglePanel">
          <i class="material-icons">
            keyboard_arrow_down
          </i>
        </a>
        <div class="panel-tabs">
          <div class="tabs-header">
            <div :class="{active: tabIndex === 0}" class="tab" @click="tabOnClick(0)">
              {{ $t('PLAYER.QUEUE') }}
            </div>
            <div :class="{active: tabIndex === 1}" class="tab" @click="tabOnClick(1)">
              {{ $t('PLAYER.MY_PLAYLIST') }}
            </div>
          </div>
          <div class="tabs-body">
            <Transition name="tab-pane-fade" mode="out-in">
              <div v-if="tabIndex === 0" key="queue" class="tab-pane">
                <PlayerPanelQueue />
              </div>
              <div v-else-if="tabIndex === 1 && isAuthenticated" key="playlist" class="tab-pane">
                <PlayerPanelMyPlaylist />
              </div>
              <div v-else-if="tabIndex === 1 && !isAuthenticated" key="playlist" class="tab-pane">
                <div class="panel-guest-user">
                  <img class="img" src="@/assets/images/empty-content/img-empty.svg" alt="Not Login" width="100%">
                  <div class="text">
                    {{ $t('PLAYER.LOG_IN_TO_START') }}
                  </div>
                  <RouterLink :to="{ name: 'signin', params: {locale: $i18n.localePath()}, query: {type: 'SIGN_IN', redirectURL: currentURL}}"
                              class="mk-btn mk-btn--default"
                  >
                    {{ $t('AUTH.LOGIN') }}
                  </RouterLink>
                </div>
              </div>
            </Transition>
          </div>
        </div>
      </div>
    </Transition>
  </div>
</template>
<script>
// import { mapState, mapGetters } from 'vuex'
import PlayerPanelQueue from '@/components/player/PlayerPanelQueue'
import PlayerPanelMyPlaylist from '@/components/player/PlayerPanelMyPlaylist'
export default {
  name: 'PlayerPanel',
  components: {
    PlayerPanelQueue,
    PlayerPanelMyPlaylist
  },
  props: {},
  data() {
    return {
      tabIndex: 0
    }
  },
  computed: {
    displayPanel() {
      return this.$store.state.player.panel
    },
    isAuthenticated() {
      return this.$store.getters.isAuthenticated
    },
    currentURL() {
      return this.$route.path
    }
  },
  watch: {},
  created() {},
  mounted() {
  },
  updated() {},
  methods: {
    togglePanel() {
      this.$store.commit('TOGGLE_PLAYER_PANEL')
    },
    tabOnClick(newIndex) {
      this.tabIndex = newIndex
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';
@import '@/assets/scss/component/button.scss';
@import '@/assets/scss/component/player.scss';

@mixin vertical-align-middle() {
  &:before{
    content:'';
    width:0;
    height:100%;
    display:inline-block;
    position:relative;
    vertical-align:middle;
  }
  > * {
    display: inline-block;
    vertical-align: middle;
  }
}
.panel {
  position: fixed;
  right: $player-panel-margin;
  bottom: calc(#{$player-height} + #{$player-panel-margin}); // 65 + 24
  height: $player-panel-height;
  width: $player-panel-width;
  border-radius: 4px;
  background-color: #ffffff;
  box-shadow: 0 2px 30px 0 rgba(0, 0, 0, 0.27);
  &-close {
    position: absolute;
    top: 24px;
    right: 24px;
    font-size: 24px;
    color: $grey-7d;
    cursor: pointer;
    transform: rotate(0deg);
    transition: transform 0.4s ease;
    &.close {
      transform: rotate(-180deg);
    }
  }
  &-guest-user {
    max-width: 375px;
    // margin: 100px auto;
    margin: 80px auto 20px;
    text-align: center;
    .text {
      margin: 26px 0;
      font-size: 20px;
      font-weight: 500;
      line-height: 1.95;
      color: $grey-50;
    }
  }
  &-tabs {
    .tabs {
      &-header {
        height: $player-tab-height;
        background-color: $grey-ec;
        user-select: none;
      }
      &-body {
        background-color: #ffffff;
      }
    }
    .tab {
      min-width: 112px;
      height: $player-tab-height;
      line-height: $player-tab-height;
      padding: 0 16px;
      font-size: 16px;
      font-weight: bold;
      display: inline-block;
      text-align: center;
      cursor: pointer;
      color: $grey-9b;
      &.active {
        color: $grey-50;
        background-color: #ffffff;
      }
    }
  }
}

// ///////////////////////////////
.panel-up-enter-active,
.panel-up-leave-active {
  transition: opacity .4s linear, transform .4s linear;
  // opacity: 1;
  transform: translateY(0);
}

.panel-up-enter,
.panel-up-leave-to {
  // opacity: 0;
  transform: translateY(500px);
}
.tab-pane-fade-enter-active,
.tab-pane-fade-leave-active {
  transition: opacity .2s linear;
  opacity: 1;
}

.tab-pane-fade-enter,
.tab-pane-fade-leave-to {
  opacity: 0;
}

@media only screen and (min-width: 1440px) {}
@media only screen and (min-width: 1024px) and (max-width: 1439.98px) {}
@media only screen and (min-width: 768px) and (max-width: 1023.98px) {}
@media only screen and (max-width: 767.98px) {
  $player-panel-height: 445px;
  $player-panel-margin: 0;
  $player-panel-width: 100%;
  $player-tab-height: 48px;
  $player-panel-title-height: 36px;

  .panel {
    position: fixed;
    right: 0;
    bottom: $player-height; // player height
    height: $player-panel-height;
    width: $player-panel-width;
    border-radius: 0px;
    &-close {
      position: absolute;
      top: 12px;
    }
    &-guest-user {
      width: 100%;
      padding: 0 24px;
    }

    &-tabs {
      .tabs {
        &-header {
          height: $player-tab-height;
        }
      }
      .tab {
        height: $player-tab-height;
        line-height: $player-tab-height;
      }
    }
  }
}
</style>
